import originUrl from './originUrl';

export default ({ location }) =>
    `${originUrl()}${location.pathname.replace(/\/$/, '')}`;
